module.exports = __webpack_public_path__ + "img/books3.78dd51a8.jpg";